import { useState, useCallback } from 'react';
import { PracticeProject } from '../../../types/practiceProjects';

export interface ProjectDialogState {
  open: boolean;
  projectId: string | null;
  projectTitle: string;
}

export function usePracticeProjectDialogs() {
  const [deleteDialog, setDeleteDialog] = useState<ProjectDialogState>({
    open: false,
    projectId: null,
    projectTitle: '',
  });

  const [publishDialog, setPublishDialog] = useState<ProjectDialogState>({
    open: false,
    projectId: null,
    projectTitle: '',
  });

  const [unpublishDialog, setUnpublishDialog] = useState<ProjectDialogState>({
    open: false,
    projectId: null,
    projectTitle: '',
  });

  const openDeleteDialog = useCallback((project: PracticeProject) => {
    setDeleteDialog({
      open: true,
      projectId: project.id,
      projectTitle: project.title,
    });
  }, []);

  const closeDeleteDialog = useCallback(() => {
    setDeleteDialog({
      open: false,
      projectId: null,
      projectTitle: '',
    });
  }, []);

  const openPublishDialog = useCallback((project: PracticeProject) => {
    setPublishDialog({
      open: true,
      projectId: project.id,
      projectTitle: project.title,
    });
  }, []);

  const closePublishDialog = useCallback(() => {
    setPublishDialog({
      open: false,
      projectId: null,
      projectTitle: '',
    });
  }, []);

  const openUnpublishDialog = useCallback((project: PracticeProject) => {
    setUnpublishDialog({
      open: true,
      projectId: project.id,
      projectTitle: project.title,
    });
  }, []);

  const closeUnpublishDialog = useCallback(() => {
    setUnpublishDialog({
      open: false,
      projectId: null,
      projectTitle: '',
    });
  }, []);

  return {
    deleteDialog,
    publishDialog,
    unpublishDialog,
    openDeleteDialog,
    closeDeleteDialog,
    openPublishDialog,
    closePublishDialog,
    openUnpublishDialog,
    closeUnpublishDialog,
  };
}
